import React, { createContext, useContext } from 'react';

const CurrencyContext = createContext();

// Доступные валюты
export const CURRENCIES = {
  RUB: { code: 'RUB', symbol: '₽', name: 'Рубли' },
  EUR: { code: 'EUR', symbol: '€', name: 'Евро' },
  USD: { code: 'USD', symbol: '$', name: 'Доллары' }
};

export const CurrencyProvider = ({ children }) => {
  // Валюта на клиенте фиксирована в RUB
  const selectedCurrency = 'RUB';

  // Оставляем совместимый API, но фактически курс фиксирован в RUB
  const changeCurrency = (currencyCode) => {
    return CURRENCIES[currencyCode] || CURRENCIES.RUB;
  };

  // Функция для получения цены в выбранной валюте
  const getPrice = (priceObj) => {
    if (!priceObj) return 0;
    
    return priceObj.rub || priceObj.priceRub || 0;
  };

  // Функция для форматирования цены с символом валюты
  const formatPrice = (priceObj) => {
    const price = getPrice(priceObj);
    const currency = CURRENCIES[selectedCurrency];
    return `${price} ${currency.symbol}`;
  };

  // Функция для получения только числового значения цены
  const getPriceValue = (priceObj) => {
    return getPrice(priceObj);
  };

  // Функция для получения символа текущей валюты
  const getCurrencySymbol = () => {
    return CURRENCIES[selectedCurrency].symbol;
  };

  // Функция для получения кода валюты
  const getCurrencyCode = () => {
    return selectedCurrency;
  };

  const value = {
    selectedCurrency,
    changeCurrency,
    getPrice,
    formatPrice,
    getPriceValue,
    getCurrencySymbol,
    getCurrencyCode,
    currencies: CURRENCIES
  };

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within CurrencyProvider');
  }
  return context;
};

export default CurrencyContext;
